import React from 'react'
import { Input, BaseForm } from '../../../../components/Form'
import { getMessage } from '../../../../lib/translator'

const handleNumericKeyDown = (e) => {
  const allowedKeys = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'Tab',
    'Control',
    'Meta',
    'Enter',
    'Shift',
  ]
  const isCtrlCombo =
    (e.ctrlKey || e.metaKey) &&
    ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())
  const isAllowed = allowedKeys.includes(e.key) || isCtrlCombo

  if (!isAllowed && !/^\d$/.test(e.key)) {
    e.preventDefault()
  }
}

class ScanRewardFilter extends BaseForm {
  render() {
    const { Form } = this.components
    const { SubmitButton, ClearButton } = this.buttons

    const numericInputProps = {
      type: 'text',
      onKeyDown: handleNumericKeyDown,
    }

    return (
      <Form className="offer-filters">
        <div className="form-fields">
          <Input
            name="campaign_id"
            required
            label={getMessage('offer.scanRewards.filter.id')}
            placeholder={getMessage('offer.scanRewards.filter.id.placeholder')}
            {...numericInputProps}
            {...this.generateStateMappers({
              stateKeys: ['campaign_id'],
              loseEmphasisOnFill: true,
              formatChange: (value) => value.replaceAll(/\D/g, ''),
            })}
          />

          <Input
            name="customer_id"
            required
            label={getMessage('offer.scanRewards.filter.customer.id')}
            placeholder={getMessage(
              'offer.scanRewards.filter.customer.id.placeholder'
            )}
            {...numericInputProps}
            {...this.generateStateMappers({
              stateKeys: ['customer_id'],
              loseEmphasisOnFill: true,
              formatChange: (value) => value.replaceAll(/\D/g, ''),
            })}
          />
        </div>
        <SubmitButton>{getMessage('offer.submit')}</SubmitButton>
        <ClearButton>{getMessage('offer.clear')}</ClearButton>
      </Form>
    )
  }
}

export default ScanRewardFilter
